<template>
  <div class="home">
    <router-view />
  </div>
</template>

<script>
import { timeout } from 'q';
export default {
  name: "Home",
  data () {
    return {
      // qrcodeUrl: '',
      // pageId: '',
      // isQrcode: false,
      // waitingImgUrl: '',
      // isShowMoblie: true
    }
  },
  watch:{
    "$route"(to,next){
      let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if(mobile) {
        this.$router.push({path:'/mobileclasslist'});
      } else {
        // this.$router.push({path:'/classlist'});
      }
    }
  },
  mounted () {

  },
  methods:{
    
  }
};
</script>
<style lang="scss" scoped>
.home{
  width:100%;
  height: 100%;
  min-width: 1000px;
  min-height: 700px;
  background: #E5FFED;
  position: fixed;
  top: 0;
  left: 0;
}
@media screen and (max-width: 1400px){
  .home{
    position: relative!important;
  }
}
</style>

